/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-09-10 10:48:44
 *
 *******************************************************/
//@flow
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { TYPEFORM_SURVEY } from 'src/constants/typeform-survey';

export default class TypeFormEmbeded extends Component<Props> {
  render() {
    const { type, email, tenantId } = this.props;
    const { enabledFrom, enabledTo, link, mode } = TYPEFORM_SURVEY[type];
    const fullLink = tenantId ? `${link}?tenantid=${tenantId}&email=${email}` : link;

    return this.checkEnabledTime(enabledFrom, enabledTo) ? (
      <div>
        <div className="button-feedback-survey" data-qa="side_panel">
          <a
            onClick={this.openForm}
            className="typeform-share button"
            href="https://embed.typeform.com/">
            <span className="icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginTop: '10px' }}>
                <path
                  d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z"
                  fill="white"
                />
              </svg>
            </span>
            <span className="text">Launch me</span>
          </a>
        </div>

        <ReactTypeformEmbed
          popup
          mode={mode}
          autoOpen={false}
          url={fullLink}
          hideHeaders
          hideFooter
          buttonText="Go!"
          style={{ width: 0, height: 0 }}
          opacity={50}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
          onSubmit={() => {
            this.onSubmitSurvey();
          }}
        />
      </div>
    ) : (
      ''
    );
  }

  // Call to open form survey
  openForm = e => {
    e.preventDefault();

    this.typeformEmbed.typeform.open();
  };

  checkEnabledTime = (from: string, to: string) => {
    const today = moment();

    // If from, to is empty, return true
    if (_.isEmpty(from) && _.isEmpty(to)) {
      return true;
    }

    const fromDate = moment(from);
    const toDate = moment(to);

    return today.isBefore(toDate) && today.isAfter(fromDate);
  };
}
